import React, { useState, useEffect } from "react";
import { toPrice, amountStrtoFloat } from "../../../../../../helpers/stringFormat";
import CsvExportModal from "../../../../../../components/generic/CsvExportModal";


function ExportBankExposureAccountModal(props) {
    const [exportData, setExportData] = useState([]);

    const getExcelDownloadData = async () => {
        let tableDataArray = props.tableData;

        if (tableDataArray.length < 1) {
            return [];
        }

        const unknownValuesAsBlank = (value) =>
            typeof value === "string"
                ? value.replace(/^(unknown)$/i, "")
                : value;
        let exportData = [["Institution Name", "Entity", "Bank Account", "> $250K", "Balance"]];
        let totalBalance = 0;

        function getAccountDescription(bankAccount) {

            const accountNumberLast4 = bankAccount.account.account_number_last_4;
            const accountDescription = unknownValuesAsBlank(bankAccount.account.account_description).trim();
            if (accountDescription === "") return accountDescription;
            const last4DigitsRegex = /\(.*\d{4}\)$/
            const hasLast4Digits = last4DigitsRegex.test(accountDescription);
            return hasLast4Digits ? accountDescription : `${accountDescription} (${accountNumberLast4.slice(-4)})`;
        }

        tableDataArray.forEach((account, _) => {
            account.entities.forEach((entity, _) => {
                entity.bankAccounts.forEach((bankAccount, _) => {
                    let balance = amountStrtoFloat(bankAccount.account.current_balance)
                    exportData.push([
                        unknownValuesAsBlank(account.institutionName),
                        unknownValuesAsBlank(entity.entityName),
                        unknownValuesAsBlank(getAccountDescription(bankAccount)),
                        unknownValuesAsBlank(balance > 250000 ? "Yes" : "No"),
                        unknownValuesAsBlank(bankAccount.account.current_balance),
                    ])
                });
            });

            totalBalance += account.balance;
        });
        exportData.push([
            "Total",
            "",
            "",
            unknownValuesAsBlank(totalBalance > 250000 ? "Yes" : "No"),
            unknownValuesAsBlank(toPrice(totalBalance)),
        ]);
        setExportData(exportData);
        return exportData;
    };

    useEffect(() => {
        getExcelDownloadData();
    }, [props.tableData]);

    return (
        <>
            <CsvExportModal
                data={exportData}
                fileName={"bank-exposure"}
                downloadMessage={"Download information for ### bank exposure account(s)."}
                modalVisible={props.csvModalVisible}
                handleCancelModal={props.handleCancelModal}
            />
        </>
    );
}

export default ExportBankExposureAccountModal; 